module.exports = __webpack_public_path__ + "static/media/tok.01e8923f.png";